import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {lightbulb} from '~/constants/InlineSvgs';
import {Typography} from '@customink/pigment-react';

import './index.scss';
/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const HelpfulTip = ({className, children}) => (
  <div className={classnames('ndx-HelpfulTip', className)}>
    <div
      className="ndx-HelpfulTip-lightbulb"
      dangerouslySetInnerHTML={renderInlineSvg(lightbulb)}
    />
    <Typography
      component="div"
      variant="uiTextDefault"
      className="ndx-HelpfulTip-content">
      {children}
    </Typography>
  </div>
);

HelpfulTip.displayName = 'HelpfulTip';

HelpfulTip.propTypes = propTypes;

export default HelpfulTip;
